import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/(marketing-site)/blog/[...slug]/error.tsx")